module fdm.common {

    angular.module('fdm.common', [
        'fdm.common.directives',
        'fdm.common.uiBootstrapOverrides']);
}